<template>
	<div class="row-fluid">
		<div class="span12 text-left" style="margin-bottom: 20px; ">
			<div class="bg_voice">
				<img style="width: 100%; border-radius:10px;" src="https://img.hsnms.com/20220414/1649925810.jpg" />
			</div>
		</div>

		<el-dialog title="选择工会组织" :visible.sync="dialogToSEl" width="90%">
			<div class="col-12" style="margin-top: -20px;">
				<div style="margin-bottom: 10px;">请输入组织关键词，点击搜索</div>
				<el-form ref="form" :model="form_s" label-width="80px">
					<el-input v-model="form_s.name" placeholder="请输入组织关键词" class="input-with-select">
						<el-button slot="append" icon="el-icon-search" @click="onSou"></el-button>
					</el-input>
				</el-form>
				<div style="margin-top: 20px;" v-for="(item, index) in Data_B">
					<div style="line-height: 20px; font-size: 16px;" @click="setUser(item)">{{item.company}}</div>
				</div>
			</div>
		</el-dialog>

		<div class="app-container">
			<div class="the-container">
				<el-tabs stretch="" v-model="usable" :tab-position="tabPosition" @tab-click="handleClick">
					<el-tab-pane v-for="(tab,index) in tabs" :key="index" :name="tab.name" :label="tab.label">
						<div v-show="usable==='1'">


							<div>
								<el-form ref="form" :model="form">
									<div style="margin-bottom: 2rem;">
										<div class="bt_hs1 tiaoti_a">姓名</div>
										<el-input class="tiaoti_a_int" placeholder="请填写你的姓名" v-model="form.username">
										</el-input>
									</div>
									<div style="margin-bottom: 2rem;">
										<div class="bt_hs1 tiaoti_a">性别</div>
										<el-select v-model="form.sex" placeholder="请选择性别" style="width: 100%;">
											<el-option label="男" value="shanghai"></el-option>
											<el-option label="女" value="beijing"></el-option>
										</el-select>
									</div>
									<div style="margin-bottom: 2rem;">
										<div class="bt_hs1 tiaoti_a">身份证号</div>
										<el-input placeholder="请填写你的身份证号" v-model="form.email"></el-input>
									</div>
									<div style="margin-bottom: 2rem;">
										<div class="bt_hs1 tiaoti_a">联系电话</div>
										<el-input placeholder="请填写你的联系电话" v-model="form.telephone"></el-input>
									</div>
									<div style="margin-bottom: 2rem;">
										<div class="bt_hs1 tiaoti_a">工会组织</div>
										<el-select @change="selectChanged" v-model="form.jurisdiction"
											placeholder="请选择组织" style="width: 100%;">
											<el-option label="我从未加入工会" value="0"></el-option>
											<el-option label="我已是工会会员" value="1"></el-option>
										</el-select>
									</div>

									<div style="margin-bottom: 2rem;">
										<div class="bt_hs1 tiaoti_a">公司名称</div>
										<el-input placeholder="请填写你所在公司名称" v-model="form.company"></el-input>
									</div>

									<el-form-item style="margin-top: 30px; margin-bottom: 50px;">
										<el-button class="bin_tijiao" type="primary" @click="onSubmit">提交申请</el-button>
									</el-form-item>
								</el-form>


							</div>


						</div>
						<div v-show="usable==='2'">
							<h1>扫码入会</h1>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</div>
		<div style="height: 20px;"></div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogToSEl: false,
				form: {
					vipid: '',
					username: '',
					sex: '',
					email: '',
					telephone: '',
					sort_id: '',
					delivery: false,
					jurisdiction: "",
					community: "",
					company: "",
					type: [],
					resource: '',
					desc: ''
				},
				form_s: {
					name: "",
				},
				Data_A: [],
				Data_B: [],
				tabPosition: 'top',
				usable: '1',
				tabs: [{
						name: '1',
						label: '申请入会'
					},
					{
						name: '2',
						label: '扫码入会'
					}
				]
			}
		},
		mounted() {
			var openid = this.$api.setOpenid();

		},
		methods: {
			onSubmit() {
				if (this.form.username.length < 3 ||
					this.form.username.length < 3 ||
					this.form.username.length < 3 ||
					this.form.username.length < 3
				) {
					this.$Message.error("数据内容不能为空！")
					return
				}
				var openid=this.$route.query.openid;
				let data = new FormData()
				data.append('username', this.form.username)
				data.append('sex', this.form.sex)
				data.append('openid', openid)
				data.append('email', this.form.email)
				data.append('telephone', this.form.telephone)
				data.append('jurisdiction', this.form.jurisdiction)
				data.append('community', this.form.community)
				data.append('company', this.form.company)
				this.$api.postAPI(
					"mutual/attribute/?type_id=2022040015&state=1&redis_time=2&openid="+openid,
					data).then(res => {
					if (res.data.code == 200) {
						this.$Message.success("添加成功！")
						console.log(res);
					}
				});

			},
			setUser(itme) {
				//选择名称
			},
			onSou() {
				var name = this.form_s.name;
				this.$api.getAPI("mutual/organizationm/?type_id=2022040016&state=1&db_k=company&db_v=" + name, {}).then(res => {
					if (res.data.code == 200) {
						this.Data_B = res.data.data.data;
						console.log(this.Data_B)
					}
				})
			},
			route1: function(myurl) {
				window.open(myurl, "_blank");
			},
			selectChanged(value) {
				if (value == 1) {
					this.dialogToSEl = true;
				}
			},
			handleClick(tab) {
				console.log(tab)
			},
		}
	}
</script>

<style>
	.t_b .col-3 .b_t_5 {
		margin-top: 5px;
	}

	.t_b .col-3 {
		margin-top: 10px;
	}


	.bin_tijiao {
		height: 50px;
		width: 100%;
		font-size: 16px
	}

	.tiaoti_a {
		margin-bottom: .5rem;
		font-size: 16px
	}

	.el-tabs__item {
		font-size: 18px !important;
	}

	.tiaoti_a_int {
		font-size: 16px;
	}

	.el-input__inner {
		padding-left: 10px !important;
		height: 45px !important;
		line-height: 45px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/sqrh.vue